import type { StockStatuses } from '../types';
import isOrderableInSecondaryBranch from './isOrderableInSecondaryBranch';

const shouldNotShowAvailabilityForBranch = (
    hideBranchesWithoutAvailability: boolean,
    status?: StockStatuses,
    statuses?: StockStatuses[]
) => {
    if (!status && (statuses?.length ?? 0) === 0) {
        return hideBranchesWithoutAvailability;
    }

    return (
        hideBranchesWithoutAvailability &&
        !isOrderableInSecondaryBranch(status, statuses)
    );
};

export default shouldNotShowAvailabilityForBranch;
